import { createReducer, on } from '@ngrx/store';

import * as PostsActions from './actions';
import { SelectedCustomerCacheInterface } from './interface/selectedCustomerCache.interface';
import { ListTabRefInterface, TabFilterRefInterface } from './interface/tabFilterRef.interface';
import { CurrentUserInfo } from '../models/currentUserInfo';
import { ICON_STATE_MAPPER, VEHICLE_FILTER_INCLUDE_CHILDREN, VEHICLE_FILTER_ALSO_DISABLED, VEHICLE_FILTER_ALSO_DATA_HIDDEN, VEHICLE_FILTER_SUBSCRIBED, VEHICLE_FILTER_HAVE_COMMUNICATED } from '../config/config.constants';
import { SelectedAssets } from './interface/selectedAssets.interface';
import { SelectedPeriodFitler } from './interface/selectedPeriod.interface';
import { GeListStateInterface } from './interface/getListState.interface';
import { Certificate } from 'crypto';
import { CompleteApplyState } from './interface/completeApplyState.interface';
import { FilterRefSetting } from './interface/filterRefSetting.interface';
import { act } from '@ngrx/effects';
import { DashboardConfig } from 'src/app/pages/dashboards/models/dashboard-models';
import { iotAssetReducer } from './iotAssets/iotAsset.reducer';
import { DashboardData } from './interface/dashboardData.interface';
import { VehicleFilters } from './interface/vehicleFilters.interface';


export const initialState: GeListStateInterface = {
  isLoading: false,
  posts: [],
  error: null
};

export const intialStateCustomerCache: SelectedCustomerCacheInterface = {
  isVirtual: false,
  isFieldTest: false,
  isSubscriptionEnded: false,
  subscriptionEndDate: null,
  vatCode: null,
  fiscalCode: null,
  contactName: null,
  contactPhone1: null,
  contactPhone2: null,
  contactEmail: null,
  contactAddress: null,
  logo: null,
  uidCountry: '',
  uidLegalRule: '',
  groups: [],
  features: [],
  children: [],
  isTachoLight: false,
  maxVehicles: null,
  name: '',
  uidParent: '',
  isHardLocked: false,
  uid: '',
  nameWithChildren: '',
  timezone:null
};

export const initialListStateTabRefFilter : ListTabRefInterface =
{
  isLoading:false,
  defaultAssetType:'VEHIC',
  tabFilterRef:[{
  id:0,
  text:'global.customer',
  enabled:true,
icon:'',
selectionMode:'all'}],

  error:null
}

export const initialSelectedAssets : SelectedAssets =
{
  assetType :'VEHIC',
  selected: [],
  totSelected:0,
  isApply:false

}



export const initialApplySelectedAssets : SelectedAssets =
{
  assetType :'VEHIC',
  selected: [],
  totSelected:0,
  isApply:false
}


export const initialListStateTaAssetChooserRefFilter : ListTabRefInterface = {
isLoading: true,
      tabFilterRef: [
        {
          id: 0,
          text: 'global.vehicles',
          enabled: true,
          icon: 'fa fa-tractor',
          selectionMode:'all'
        },
         {
           id: 1,
           text: 'global.driver',
           enabled: true,
           icon:'fa fa-user',
           selectionMode:'all'
         },
        //  {
        //   id: 2,
        //   text: 'global.menu.fleets',
        //   enabled: true,
        //   icon:'fa fa-truck'
        // },
        // {
        //   id: 3,
        //   text: 'global.menu.teams',
        //   enabled: true,
        //   icon:'fa fa-group'
        // },

      ],
      error: null,
      defaultAssetType:'VEHIC'
    }

export const initialStateUser : CurrentUserInfo = {
  impersonatingOtherUser :false,
  isArgo: false,
  oem: '',
  uidOem: '',
  user:null,
  customer: null,
  menu: []

}

export const initialPeriod : SelectedPeriodFitler = {
  fromDtPicker:0,
  toDtPicker:0,
  timespanSel:'',
  isApply:false

}


export const initialCompleteApplyState : CompleteApplyState =
{
  isLoading:false,
  applyCustomer:intialStateCustomerCache,
  applySelectedAssets:initialSelectedAssets,
  applySelectedPeriod:initialPeriod,
  includeChildrens:false,
  isCapped:false,
  error:null

}

export const initialFilterRefSetting: FilterRefSetting =
{
  isSetting:true,
  showFilter:true,
  showDetailAssets:true,
  showIncludeChildrens:false,

}

export const initialVehicleFilters: VehicleFilters = {
  includeChildren: VEHICLE_FILTER_INCLUDE_CHILDREN,
  alsoDisabled: VEHICLE_FILTER_ALSO_DISABLED,
  alsoDataHidden: VEHICLE_FILTER_ALSO_DATA_HIDDEN,
  subscribed: VEHICLE_FILTER_SUBSCRIBED,
  haveCommunicated: VEHICLE_FILTER_HAVE_COMMUNICATED
};

export const initialDashboardState: DashboardConfig[] = [];
export const initialData: any = {};

export const reducersCustomers = createReducer(
  initialState,
  on(PostsActions.getCustomers, (state) => ({ ...state, isLoading: true })),
  on(PostsActions.getSuccesCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    posts: action.posts
  })),
  on(PostsActions.getFailureCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error
  }))
);

export const reducersVehiclesOfCustomers = createReducer(
  initialState,
  on(PostsActions.getVehiclesOfCustomers, (state) => ({
    ...state,
    isLoading: true
  })),
  on(PostsActions.getSuccesVehiclesOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    posts: action.posts
  })),
  on(PostsActions.getFailureVehiclesOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error
  }))
);

export const reducerTrailersOfCustomers = createReducer(
  initialState,
  on(PostsActions.getTrailersOfCustomers, (state) => ({
    ...state,
    isLoading: true
  })),
  on(PostsActions.getSuccesTrailersOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    posts: action.posts
  })),
  on(PostsActions.getFailureTrailersOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error
  }))
);


export const reducersFleetsOfCustomers = createReducer(
  initialState,
  on(PostsActions.getFleetsOfCustomers, (state) => ({
    ...state,
    isLoading: true
  })),
  on(PostsActions.getSuccesFleetsOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    posts: action.posts
  })),
  on(PostsActions.getFailureFleetsOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error
  }))
);

export const reducersDriversOfCustomers = createReducer(
  initialState,
  on(PostsActions.getDriversOfCustomers, (state) => ({
    ...state,
    isLoading: true
  })),
  on(PostsActions.getSuccesDriversOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    posts: action.posts
  })),
  on(PostsActions.getFailureDriversOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error
  }))
);

export const reducersTeamsOfCustomers = createReducer(
  initialState,
  on(PostsActions.getTeamsOfCustomers, (state) => ({
    ...state,
    isLoading: true
  })),
  on(PostsActions.getSuccesTeamsOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    posts: action.posts
  })),
  on(PostsActions.getFailureTeamsOfCustomers, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error
  }))
);

export const reducersSelectedCustomerCache = createReducer(
  intialStateCustomerCache,
  on(PostsActions.setSelectedCustomerCache, (state, action) => ({
    ...state,
    isVirtual: action.isVirtual,
    name: action.name,
    uid: action.uid,
    timezone : action.timezone
  }))
);

export const reducersSetTabFilterRef = createReducer(
  initialListStateTabRefFilter,
  on(PostsActions.setTabFilterRef, (state,action) => ({
    ...state,
    isLoading: true,
    defaultAssetType:action.defaultAssetType,
    tabFilterRef:action.tabFilterRef
  })),

);

export const reducerSetTabAssetChooserRef = createReducer(
  initialListStateTaAssetChooserRefFilter,
  on(PostsActions.setTabAssetChooserRef, (state,action) => ({
    ...state,
    isLoading: true,
    defaultAssetType : action.defaultAssetType,
    tabFilterRef:action.tabFilterRef
  })),

);

export const reducersUser = createReducer(
  initialStateUser,
  on(PostsActions.setUser, (state,action) => ({
    ...state,
    impersonatingOtherUser:action.impersonatingOtherUser,
    user:action.user,
    customer: action.customer,
    menu:action.menu,
  })),

);

export const reducersApplySelectedCustomer = createReducer(
  intialStateCustomerCache,
  on(PostsActions.setApplySelectedCustomer , (state, action) => ({
    ...state,
    state:action,
    isVirtual: action.isVirtual,
    name: action.name,
    uid: action.uid,
    timezone :action.timezone
  }))
);

export const reducersSetSelectedAssets = createReducer(
  initialSelectedAssets,
  on(PostsActions.setSelectedAssets , (state, action) => ({
    ...state,
    assetType: action.assetType,
    selected: action.selected,
    totSelected : action.selected.length,
    isApply:action.isApply,
    isCapped: action.isCapped ?? (action.selected.length >= 100)
  }))
);


export const reducersApplySelectedAssets = createReducer(
  initialApplySelectedAssets,
  on(PostsActions.setApplySelectedAssets , (state, action) => ({
    ...state,
    assetType: action.assetType,
    selected: action.selected,
    totSelected : action.selected.length,
    isApply:action.isApply,
    isCapped: action.isCapped ?? (action.selected.length >= 100)
  }))
);


export const reducersSetSelectedPeriod = createReducer(
  initialPeriod,
  on(PostsActions.setSelectedPediod , (state, action) => ({
    ...state,
    fromDtPicker:action.fromDtPicker,
    toDtPicker:action.toDtPicker,
    timespanSel:action.timespanSel

  }))
);

export const reducersApplySelectedPeriod = createReducer(
  initialPeriod,
  on(PostsActions.setApplySelectedPediod , (state, action) => ({
    ...state,
    fromDtPicker:action.fromDtPicker,
    toDtPicker:action.toDtPicker,
    timespanSel:action.timespanSel,
    isApply:true

  }))
);


export const reducersIsApplySelectedAssets = createReducer(
  initialSelectedAssets,
  on(PostsActions.setIsApplySelectedAssets , (state, action) => ({
    ...state,
    isApply:action.isApply
  }))
);

export const reducerCompleteApplyState = createReducer(
  initialCompleteApplyState,
  on(PostsActions.getCompleteApplyState , (state) => ({
    ...state,
    isLoading:true
  })),
  on(PostsActions.setCompleteApplyStateCustomer , (state,action) => ({
    ...state,
    applyCustomer : action,
    isLoading:true
  })),
  on(PostsActions.setCompleteApplyStateSelectedAssets , (state,action) => {
    // Calcola se il cap è stato applicato - usa isCapped dall'action se presente, altrimenti calcola
    const isCapped = action.isCapped ?? (action.totSelected >= 100); // MAX_ASSETS_LOAD
    return {
      ...state,
      applySelectedAssets : action,
      isCapped,
      isLoading:true
    };
  }),
  on(PostsActions.setCompleteApplyStateSelectedPeriod , (state,action) => ({
    ...state,
    applySelectedPeriod : action.applySelectedPeriod,
    isLoading:true
  })),
  on(PostsActions.setCompleteApplyStateIncludeChildrens , (state,action) => ({
    ...state,
    includeChildrens : action.includeChildrens,
    isLoading:true
  })),
  on(PostsActions.setCompleteApplyState , (state,action) => {
    // Calcola se il cap è stato applicato - usa isCapped dall'action se presente, altrimenti calcola
    const isCapped = action.applySelectedAssets?.isCapped ?? (action.applySelectedAssets?.totSelected >= 100); // MAX_ASSETS_LOAD
    return {
      ...state,
      applyCustomer:action.applyCustomer,
      applySelectedAssets:action.applySelectedAssets,
      applySelectedPeriod : action.applySelectedPeriod,
      isCapped,
      isLoading:true
    };
  }),

);


export const reducerFilterRefSetting = createReducer(
  initialFilterRefSetting,
  on(PostsActions.setFilterRefSetting , (state, action) => ({
    ...state,
    isSetting:action.isSetting,
    showFilter:action.showFilter,
    showDetailAssets:action.showDetailAssets,
    showIncludeChildrens:action.showIncludeChildrens,
    showStaticCustomerLabel:action.showStaticCustomerLabel

  })),
  on(PostsActions.setFilterRefSettingIncludeChildrens , (state, action) => ({
    ...state,
    includeChildrens:action.showIncludeChildrens

  })),


);

export const reducerDashboards = createReducer(
  initialDashboardState,
  on(PostsActions.getDashboards, (state) => ({ ...state })),
  on(PostsActions.saveDashboardConfig, (state, action) => ({
    ...state,
    dashboards: action.dashboards
  })),
  on(PostsActions.deleteDashboard, (state, action) => ({
    ...state,
    dashboardId: action.dashboardId
  })),
)

export const reducerDashboardData = createReducer(
  initialData,
  on(PostsActions.getSignalsTrendDataAction, (state, action) => ({
    ...state,
    dataType: action.data,
    loadingSignalsData: true
  })),
  on(PostsActions.getSignalsTrendDataSuccess, (state, action) => ({
    ...state,
    signalsData: action.data,
    loadingSignalsData: false
  })),
  on(PostsActions.getSignalsTrendDataFailure, (state, action) => ({
    ...state,
    error: action.error,
    loadingSignalsData: false
  })),

  on(PostsActions.getSignalsCatalogAction, (state, action) => ({
    ...state,
    dataType: action.data,
    loadingCatalog: true
  })),
  on(PostsActions.getSignalsCatalogSuccess, (state, action) => ({
    ...state,
    signalsCatalog: action.data,
    loadingCatalog: false
  })),
  on(PostsActions.getSignalsCatalogFailure, (state, action) => ({
    ...state,
    error: action.error,
    loadingCatalog: false
  })),

  on(PostsActions.getKpiDataAction, (state, action) => ({
    ...state,
    dataType: action.data,
    loadingKpiData: true,
    loadingCompositeKpiData: action.isVehicleStatsIncluded ? true : state.loadingCompositeKpiData
  })),
  on(PostsActions.getKpiVehicleStat, (state, action) => ({
    ...state,
    compositeKpiData: action.data,
    loadingCompositeKpiData: false,
  })),
  on(PostsActions.getKpiDataSuccess, (state, action) => ({
    ...state,
    kpiData: action.data,
    loadingKpiData: false
  })),
  on(PostsActions.getKpiDataFailure, (state, action) => ({
    ...state,
    error: action.error,
    loadingKpiData: false
  })),

  on(PostsActions.getMachineDataAction, (state, action) => ({
    ...state,
    dataType: action.data,
    loadingMachineData: true
  })),
  on(PostsActions.getMachineDataSuccess, (state, action) => ({
    ...state,
    machineData: action.data,
    loadingMachineData: false
  })),
  on(PostsActions.getMachineDataFailure, (state, action) => ({
    ...state,
    error: action.error,
    loadingMachineData: false
  })),

  on(PostsActions.getCompositeSignalDataAction, (state, action) => ({
    ...state,
    dataType: action.data,
    loadingCompositeSignalData: true
  })),
  on(PostsActions.getCompositeSignalDataSuccess, (state, action) => ({
    ...state,
    compositeSignalData: action.data,
    loadingCompositeSignalData: false
  })),
  on(PostsActions.getCompositeSignalDataFailure, (state, action) => ({
    ...state,
    error: action.error,
    loadingCompositeSignalData: false
  })),

  on(PostsActions.getTableDataAction, (state, action) => ({
    ...state,
    dataType: action.data,
    loadingTableData: {
      ...state.loadingTableData,
      [action.data.tableType]: true
    }
  })),
  on(PostsActions.getTableDataSuccess, (state, action) => ({
    ...state,
    tableData: {
      ...state.tableData,
      [action.tableType]: action.data
    },
    loadingTableData: {
      ...state.loadingTableData,
      [action.tableType]: false
    }
  })),
  on(PostsActions.getTableDataFailure, (state, action) => ({
    ...state,
    error: action.data.error,
    loadingTableData: {
      ...state.loadingTableData,
      [action.tableType]: false
    }
  })),

  on(PostsActions.resetDashboardDataStore, (state, action) => ({
    ...state,
    ...action.data
  })),
);

export const logoutReducer = createReducer(
  initialState,
  on(PostsActions.logout, (state) => ({
    ...state
  }))
);

export const reducerVehicleFilters = createReducer(
  initialVehicleFilters,
  on(PostsActions.setVehicleFilters, (state, action) => ({
    ...state,
    includeChildren: action.includeChildren,
    alsoDisabled: action.alsoDisabled,
    alsoDataHidden: action.alsoDataHidden,
    subscribed: action.subscribed,
    haveCommunicated: action.haveCommunicated
  }))
);

// Export IoT Assets reducer
export const reducersIotAssets = iotAssetReducer;
